export const getImageAtSize = (url, size = 428) => {
    if (!url) return url;
    const sizePattern = /_w\d+(?=\.\w+$)/;

    return sizePattern.test(url)
        ? url.replace(sizePattern, `_w${size}`)
        : url.replace(/(\.\w+)$/, `_w${size}$1`);
};

